import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import TorqueConverter from '../components/tools/TorqueConverter';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'Nm to lb-ft Calculator | Torque Unit Converter | AUTOXIUM';
const PAGE_DESCRIPTION = 'Convert torque instantly between N·m, lb-ft, lb-in, kgf·m, kgf·cm, oz-in, and dyn·cm. Free online torque calculator with formulas and adjustable precision.';

const TorqueConverterPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="torque-converter-page">
      <PageHero
        eyebrow="Engineering Utilities / Conversion"
        title="Nm ↔ lb-ft Calculator"
        description="Convert torque between Newton-Meters, Pound-Feet, Pound-Inches, Kilogram-Force Meters, Kilogram-Force Centimeters, Ounce-Inches, and Dyne-Centimeters. Enter a value in any unit and the rest update in real time."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="torque-converter-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <TorqueConverter />
          <ToolGuideCta guidePath="/tools/torque-calculator/guide" toolName="Nm ↔ lb-ft Calculator" />
        </div>
      </section>
    </div>
  );
};

export default TorqueConverterPage;
